import {BooleanUDF} from "./UDFs/BooleanUDF";
import {StringUDF} from "./UDFs/StringUDF";
import {NumberUDF} from "./UDFs/NumberUDF";

export class CycleCountConfiguration {


  BeepOnUniqueTags: BooleanUDF;

  BridgeCode: StringUDF;

  CycleCountScreenType: StringUDF;

  EndPointMode: StringUDF;

  ExpectedReportId: NumberUDF;

  FilterLabelZoneType: StringUDF;

  FilterLabelStoreID: StringUDF;

  FilterLabelDepartment: StringUDF;

  LastCycleCountReportId: NumberUDF;

  PowerLevel: NumberUDF;

  SyncInterval: NumberUDF;

  ThingTypeCodeSync: StringUDF;

  RetrySyncInterval: NumberUDF;

  RetrySyncAttempts: NumberUDF;

  RetrySyncButton: BooleanUDF;

  UpdateRemainingDelay: NumberUDF;

  get(): any {
    return {
      BeepOnUniqueTags: this.BeepOnUniqueTags.value,
      BridgeCode: this.BridgeCode.value,
      CycleCountScreenType: this.CycleCountScreenType.value,
      EndPointMode: this.EndPointMode.value,
      ExpectedReportId: this.ExpectedReportId.value,
      FilterLabelZone: this.FilterLabelZoneType.value,
      FilterLabelStoreID: this.FilterLabelStoreID.value,
      FilterLabelDepartment: this.FilterLabelDepartment.value,
      LastCycleCountReportId: this.LastCycleCountReportId.value,
      PowerLevel: this.PowerLevel.value,
      RetrySyncAttempts: this.RetrySyncAttempts.value,
      RetrySyncButton: this.RetrySyncButton.value,
      RetrySyncInterval: this.RetrySyncInterval.value,
      SyncInterval: this.SyncInterval.value,
      ThingTypeCodeSync: this.ThingTypeCodeSync.value,
      UpdateRemainingDelay: this.UpdateRemainingDelay.value
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/cycleCount.config.ts